import { render, staticRenderFns } from "./appointment_fee_contract_show.vue?vue&type=template&id=23f2e7fa&scoped=true"
import script from "./appointment_fee_contract_show.vue?vue&type=script&lang=js"
export * from "./appointment_fee_contract_show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f2e7fa",
  null
  
)

export default component.exports